import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { InterceptorHttpParams } from '../../../domain/interceptor.model';
import { BlockerService } from '../service/blocker.service';

@Injectable()
export class BlockerInterceptor implements HttpInterceptor {

    constructor(private blockerService: BlockerService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let blocking = true;
        if (req.params instanceof InterceptorHttpParams) {
            blocking = (req.params as InterceptorHttpParams).blocking;
        }
        if (blocking) {
            this.blockerService.increment();
        }

        return next.handle(req)
            .pipe(
                finalize(() => {
                    if (blocking) {
                        this.blockerService.decrement();
                    }
                })
            );
    }
}
